import { connect } from 'react-redux';
import { getDuperbrowseNavigation, getIsDuperbrowseActive, getPreloadingEnabled } from '../../../Duperbrowse/redux/selectors';
import { movePrev, moveNext } from '../../../Duperbrowse/redux/actionCreators';
import { getIsDuperbrowseAllowed } from '../../../DeviationPage/redux/selectors';
const mapStateToProps = (state)=>({
        isEnabled: getIsDuperbrowseAllowed(state),
        navigation: getDuperbrowseNavigation(state),
        duperActive: getIsDuperbrowseActive(state),
        preloadEnabled: getPreloadingEnabled(state)
    });
const mapDispatchToProps = {
    moveNext,
    movePrev
};
export default connect(mapStateToProps, mapDispatchToProps);
